/* Poolhandel customer journey events. Uses the existing Shopify event bus only.
 * Never sends contact fields, free text, measurements, URLs or browser identifiers.
 * Consent is read through Shopify's public Customer Privacy API on every event.
 */
(function (window, document) {
  'use strict';
  if (window.PoolhandelJourney) return;

  var EVENT_NAMES = new Set([
    'model_selected', 'configuration_completed', 'cart_add_success',
    'quote_opened', 'quote_submit_attempted', 'quote_submit_success',
    'comparison_ready', 'product_opened'
  ]);
  var JOURNEYS = new Set(['lamell', 'pool', 'spalock', 'spa_comparison']);
  var SERIES = new Set(['top-one', 'nova-light', 'nova-plus', 'top-nova', 'sveltea', 'beach']);
  var POOL_TYPES = new Set(['thermo', 'tra', 'glasfiber', 'stal']);
  var PUBLIC_MODEL_KEYS = new Set(["aphrodite", "atlantis", "aurora", "beach-line", "classic-line", "coast-line", "erato", "family", "gardenpool-rektangular", "glasfiberpool-arcadia", "glasfiberpool-arcadia-700", "glasfiberpool-minerva", "glasfiberpool-olympia", "glasfiberpool-pegasus", "glasfiberpool-pico", "glasfiberpool-sirius", "glasfiberpool-solaris", "glasfiberpool-taurus", "glasfiberpool-thalia-250", "glasfiberpool-thalia-390", "kleio", "miami-eight", "miami-kidney", "miami-lagoon", "miami-octagon", "miami-oval", "miami-rectangular", "miami-round", "poolhandels-kompletta-poolpaket-bas", "reno-line", "sveltea", "top-nova", "top-one", "trapool-projekt"]);
  var observedSuccessMarkers = new WeakSet();

  function permitted() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!privacy && typeof privacy.analyticsProcessingAllowed === 'function'
        && privacy.analyticsProcessingAllowed() === true;
    } catch (_) { return false; }
  }

  function id(value) {
    var result = typeof value === 'number' && Number.isSafeInteger(value) ? String(value) : value;
    return typeof result === 'string' && /^[1-9]\d{0,19}$/.test(result) ? result : null;
  }

  function catalogueKey(value) {
    // Only pass keys from an application's public product/model catalogue to this field.
    return typeof value === 'string' && PUBLIC_MODEL_KEYS.has(value) ? value : null;
  }

  function sanitize(input) {
    if (!input || !JOURNEYS.has(input.journey) || input.test_mode === true) return null;
    var data = {schema_version: 1, journey: input.journey};
    ['product_id', 'variant_id'].forEach(function (field) {
      var value = id(input[field]);
      if (value) data[field] = value;
    });
    var model = catalogueKey(input.model_id);
    if (model) data.model_id = model;
    if (SERIES.has(input.series)) data.series = input.series;
    if (POOL_TYPES.has(input.pool_type)) data.pool_type = input.pool_type;
    if (typeof input.solar === 'boolean') data.solar = input.solar;
    if (typeof input.selected === 'boolean') data.selected = input.selected;
    if (typeof input.purchase_ready === 'boolean') data.purchase_ready = input.purchase_ready;
    if (Array.isArray(input.product_ids)) {
      data.product_ids = Array.from(new Set(input.product_ids.map(id).filter(Boolean))).slice(0, 4);
    }
    return data;
  }

  function track(name, input) {
    // No event queue: denied, unavailable, failed and pre-consent events are dropped.
    if (!EVENT_NAMES.has(name) || !permitted()) return false;
    var data = sanitize(input);
    var analytics = window.Shopify && window.Shopify.analytics;
    if (!data || !analytics || typeof analytics.publish !== 'function') return false;
    if (name === 'comparison_ready' && (!data.product_ids || data.product_ids.length < 2)) return false;
    try {
      var result = analytics.publish('poolhandel:' + name, data);
      if (result && typeof result.catch === 'function') result.catch(function () {});
      return result !== false;
    } catch (_) { return false; }
  }

  window.PoolhandelJourney = Object.freeze({track: track, version: '1.0.0'});

  document.addEventListener('ph:journey-event', function (event) {
    var data = event.detail;
    if (data && typeof data.event === 'string') track(data.event, data);
  });
  document.addEventListener('ph:comparison-model-selected', function (event) {
    var data = event.detail || {};
    track('model_selected', {journey: 'spa_comparison', product_id: data.productId, selected: data.selected});
  });
  document.addEventListener('ph:comparison-ready', function (event) {
    var data = event.detail || {};
    track('comparison_ready', {journey: 'spa_comparison', product_ids: data.productIds});
  });
  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest && event.target.closest('[data-spa-product-link][data-product-id]');
    if (target) track('product_opened', {journey: 'spa_comparison', product_id: target.dataset.productId});
  });

  function confirmNativeQuotes(root) {
    root.querySelectorAll('[data-ph-quote-success][data-journey]').forEach(function (marker) {
      if (observedSuccessMarkers.has(marker)) return;
      observedSuccessMarkers.add(marker);
      // This marker must be rendered only in Liquid form.posted_successfully?.
      track('quote_submit_success', {
        journey: marker.dataset.journey,
        product_id: marker.dataset.productId,
        model_id: marker.dataset.modelId,
        test_mode: marker.dataset.testMode === 'true'
      });
    });
  }

  function requestPrivacyAPI() {
    if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
      try {
        window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function () {});
      } catch (_) { /* Missing API fails closed. Never infer or set consent. */ }
    }
  }

  requestPrivacyAPI();
  function ready() { requestPrivacyAPI(); confirmNativeQuotes(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once: true});
  else ready();
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelectorAll) confirmNativeQuotes(event.target);
  });
})(window, document);
